module.exports = __webpack_public_path__ + "static/media/course_ru.72fe2fb9.jpg";